import Task from "../../model2/task/task"
import ModelEntity from "../../model2/model-entity"
import {EntityType} from "../../gd/const/item"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import {OPTIONS} from "./save-as-template-options"

// The value of the "Create new" option of the task type dropdown - never a task type id
export const CREATE_NEW_TASK_TYPE = 'new'

// What TaskType falls back to when it is built without one
const DEFAULT_TASK_TYPE_ICON = 'task'

export type CustomFieldOption = {
    id      : ID
    title   : string
}

export default class SaveAsTemplateModel extends ModelEntity {

    public taskTypeId             : ID
    public selectedFields         : string[]
    public selectedCustomFieldIds : ID[]

    // The task type created when "Create new" is picked. Same fieldIds as the task type model, so
    // the gd.fields.taskType.* form elements of TaskTypeSettings_General render them as they are.
    public name                   : string
    public icon                   : string
    public isDefault              : boolean

    // The task type the template content is taken from. A new task type has no custom fields of
    // its own yet, so the content keeps coming from the type that was selected before "Create new".
    public sourceTaskTypeId       : ID

    private task : Task

    constructor(task: Task) {
        super('id', EntityType.DYNAMIC_MODEL)
        this.task                   = task
        this.taskTypeId             = task.taskTypeId
        this.sourceTaskTypeId       = task.taskTypeId
        this.name                   = ''
        this.icon                   = DEFAULT_TASK_TYPE_ICON
        this.isDefault              = false
        this.selectedFields         = OPTIONS.map(o => o.id)
        this.selectedCustomFieldIds = this.customFieldOptions.map(o => o.id)
    }

    get isCreateNew(): boolean {
        return this.taskTypeId === CREATE_NEW_TASK_TYPE
    }

    // Re-computed on each access so changing taskTypeId via the dropdown
    // automatically narrows the list to fields available in the new task type.
    get customFieldOptions(): CustomFieldOption[] {
        return buildCustomFieldOptions(this.task, this.isCreateNew ? this.sourceTaskTypeId : this.taskTypeId)
    }

    validate(): ErrorProto[] | null {
        if (!this.taskTypeId) return [new ErrorFieldRequired(gd.fields.task.taskTypeId)]
        // trimmed: the endpoint refuses a blank title, so a name of spaces must not reach it
        if (this.isCreateNew && !this.name?.trim()) return [new ErrorFieldRequired(gd.fields.taskType.name)]
        return null
    }
}

function buildCustomFieldOptions(task: Task, taskTypeId: ID): CustomFieldOption[] {
    const taskType   = gd.session.taskTypes.get(taskTypeId)
    const allowedIds = new Set(taskType?.customFields || [])

    return _.compact(
        _.map(task.customFieldsData, (value: any, id: ID) => {
            if (value == null) return null
            if (!allowedIds.has(id)) return null
            const cf = gd.session.customFields.get(id)
            return cf ? { id, title: cf.displayName } : null
        })
    ) as CustomFieldOption[]
}
